import { Box, Grid, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import ContestTable from "./components/ContestTable"
import PendingQuestionTable from "./components/PendingQuestionTable"
import Header from "components/Header/Header"
import { useTheme } from "@mui/system"
import AppButton from "components/StyledComponents/AppButton"
import { useHistory } from "react-router-dom"
import { createBreadcrumbs } from "../../../../helpers/breadCrumbs"
import { useDispatch } from "react-redux"
import { learningDevelopmentActions } from "redux/L&D/slice/user"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import { deleteMultipleTriviaContestAction } from "redux/L&D/actions"

const TriviaContest = () => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)
  const history = useHistory()
  const [selectedContestCount, setSelectedContestCount] = useState(0)
  const [selectedContests, setSelectedContests] = useState([])
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [isAllSelected, setIsAllSelected] = useState(false)

  const styles = {
    heading: {
      color: theme.palette.text.primary
    },
    btnAddContest: {
      paddingLeft: "67px",
      paddingRight: "67px"
    },
    btnDelete: {
      color: theme.palette.red.main,
      borderColor: theme.palette.red.main,
      paddingLeft: "80px",
      paddingRight: "80px",
      marginRight: "16px",
      "&:hover": {
        borderColor: theme.palette.red.main,
        backgroundColor: theme.palette.background.default
      }
    },
    btnQuestion: {
      paddingLeft: "47px",
      paddingRight: "47px",
      marginRight: "16px"
    }
  }

  const toggleDeletePopup = () => {
    setIsDeletePopupOpen((prev) => !prev)
  }

  function removeElements(data) {
    return data !== false && data !== "disabled"
  }

  const deleteAllContest = () => {
    const payload = selectedContests.filter(removeElements)
    dispatch(deleteMultipleTriviaContestAction(payload))
    setSelectedContestCount(0)
    setSelectedContests(
      selectedContests.map((contest) => (contest === "disabled" ? contest : false))
    )
    setIsAllSelected(false)

    setIsDeletePopupOpen((prev) => !prev)
  }

  const onNewContestClick = () => {
    dispatch(learningDevelopmentActions.setTriviaId(""))
    history.push("/learning_development/dashboard/trivia-contest/new-trivia-contest")
  }

  useEffect(() => {
    document.title = "Trivia Contest"
    dispatch(learningDevelopmentActions.setUploadQuestionsData([]))
    setBreadcrumbs(createBreadcrumbs())
  }, [])

  return (
    <Grid container>
      <DeleteConfirmationDialog
        open={isDeletePopupOpen}
        onClose={() => setIsDeletePopupOpen(false)}
        onDelete={deleteAllContest}
        description={`Are you Sure to Delete ${
          selectedContestCount > 1 ? `All` : ""
        } The Selected ${selectedContestCount > 1 ? `Contests` : `Contest`} ?`}
      />
      <Grid item xs={12} spacing={1}>
        <Header title="Trivia Contest & Questions" breadCrumbs={breadcrumbs}>
          {selectedContestCount ? (
            <AppButton styles={styles.btnDelete} onClick={toggleDeletePopup}>
              Delete
            </AppButton>
          ) : null}
          <AppButton
            onClick={() => history.push("/learning_development/dashboard/question-bank")}
            styles={styles.btnQuestion}>
            Trivia Question Bank
          </AppButton>
          <AppButton onClick={onNewContestClick} styles={styles.btnAddContest}>
            + New Contest{" "}
          </AppButton>
        </Header>
      </Grid>
      <Grid
        container
        direction={history?.location?.state?.isPendingApproval ? "column-reverse" : "column"}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={styles.heading} variant="h2">
              Trivia Contest
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable
              {...{
                setIsAllSelected,
                isAllSelected,
                selectedContestCount,
                setSelectedContestCount,
                selectedContests,
                setSelectedContests
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Box height={35} />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={styles.heading} variant="h2">
              Pending Questions
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <PendingQuestionTable />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TriviaContest
